module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "number_field",
    class: {
      top: _vm.numbers.length
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.number),
      expression: "number"
    }],
    staticClass: "inp",
    attrs: {
      "type": "number",
      "maxlength": "7",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.number)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.calculate()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.number = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _c('div', {
    staticClass: "settings__container",
    style: ({
      backgroundColor: _vm.showSettings ? 'white' : 'transparent'
    })
  })]), _c('div', {
    staticClass: "res"
  }, _vm._l((_vm.numbers), function(num, index) {
    return _c('div', {
      staticClass: "num",
      class: ['_' + num.title.value, {
        'bounce': num.title.value == _vm.repeat
      }]
    }, [_c('span', {
      staticClass: "num__delete",
      on: {
        "click": function($event) {
          _vm.numberDelete(index)
        }
      }
    }, [_vm._v("×")]), _vm._l((num), function(value, key) {
      return (value.value) ? _c('div', {
        class: key
      }, [_c('span', {
        staticClass: "num__symbol",
        domProps: {
          "innerHTML": _vm._s(value.symbol)
        }
      }, [_c('br')]), _c('span', {
        staticClass: "num__value",
        domProps: {
          "innerHTML": _vm._s(value.value)
        }
      })]) : _vm._e()
    })], 2)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fb8b1e8"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 28
// module chunks = 0